import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '@/store'
import statementUtils from './statement-utils'
import { IStatement } from '@/model/statement'
import processStatements from './process-statements';
import statementStore from '@/store/statement/statement-store';

export default async function fetchStatement(context: BareActionContext<StatementState, RootState>, id: string) {
    statementStore.commitSetIsLoading({isLoading: true})
    statementUtils.statementService.getById(id).then((statement: IStatement) => {
        processStatements(context, [statement])
    })
}
